import { initCetusSDK } from '@cetusprotocol/cetus-sui-clmm-sdk';
import { config } from '@config';

export const cetusClmmSDK = initCetusSDK({
  network: config.sui_network as 'testnet' | 'mainnet',
  fullNodeUrl: config.fullnode,
});
